var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "panel panel-default scope-attach-padding ls-flex ls-flex-column fill",
      attrs: { id: "question_type_selector_" + _vm.id }
    },
    [
      _c("div", { staticClass: "panel-heading" }, [
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              type: "button",
              "data-dismiss": "modal",
              "aria-label": "Close"
            },
            on: { click: _vm.closeButton }
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
        _c("h4", { staticClass: "panel-title" }, [_vm._v(_vm._s(_vm.title))])
      ]),
      _c("div", { staticClass: "panel-body scoped-overflow-scroll" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-4 ls-ba" }, [
              _c(
                "div",
                {
                  staticClass: "panel-group",
                  attrs: {
                    id: "accordion_question_type_selector_" + _vm.id,
                    role: "tablist",
                    "aria-multiselectable": "true"
                  }
                },
                _vm._l(_vm.structureArray, function(
                  groupStructureArray,
                  groupTitle
                ) {
                  return _c(
                    "div",
                    { key: groupTitle, staticClass: "panel panel-default" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "panel-heading",
                          attrs: { role: "tab", id: "heading_" + groupTitle }
                        },
                        [
                          _c("h4", { staticClass: "panel-title" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  role: "button",
                                  "data-toggle": "collapse",
                                  href: "#collapsible_" + groupTitle,
                                  "data-parent":
                                    "#accordion_question_type_selector_" +
                                    _vm.id
                                },
                                on: {
                                  click: function($event) {
                                    groupStructureArray.uncollapsed = !groupStructureArray.uncollapsed
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      groupStructureArray.questionGroupName
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "panel-collapse",
                          class: groupStructureArray.collapsed
                            ? "collapse"
                            : "",
                          attrs: {
                            id: "collapsible_" + groupTitle,
                            role: "tabpanel",
                            "aria-labelledby": groupTitle
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "panel-body ls-space padding all-0"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "list-group ls-space margin all-0"
                                },
                                _vm._l(
                                  groupStructureArray.questionTypes,
                                  function(questionType) {
                                    return _c(
                                      "a",
                                      _vm._b(
                                        {
                                          key:
                                            questionType.type +
                                            questionType.name,
                                          staticClass: "list-group-item",
                                          class: _vm.isSelected(questionType),
                                          attrs: {
                                            href: "#",
                                            "data-selector":
                                              questionType.class ||
                                              questionType.type,
                                            "data-key": questionType.type
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.selectQuestionType(
                                                questionType
                                              )
                                            }
                                          }
                                        },
                                        "a",
                                        questionType.extraAttributes,
                                        false
                                      ),
                                      [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(questionType.title) +
                                            "\n                          "
                                        ),
                                        _vm.debug
                                          ? _c("em", { staticClass: "small" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("translate")("Type:")
                                                ) +
                                                  " " +
                                                  _vm._s(questionType.type)
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _c("div", { staticClass: "col-xs-8" }, [
              _c("div", { staticClass: "container-center" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-12" }, [
                    _c("h3", [
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm._f("translate")("Question type preview"))
                        )
                      ]),
                      _c("br"),
                      _vm.currentlySelectedType
                        ? _c(
                            "p",
                            {
                              attrs: {
                                id:
                                  "selector__question_type_selector-currentSelected"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currentlySelectedType.title) +
                                  " "
                              )
                            ]
                          )
                        : _c("p", {
                            attrs: {
                              id:
                                "selector__question_type_selector-currentSelected"
                            }
                          })
                    ])
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass: "row",
                    attrs: { id: "selector__question_type_selector-detailPage" }
                  },
                  [
                    _vm.currentlySelectedType
                      ? _c("div", {
                          staticClass: "col-sm-12",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.currentlySelectedType.detailpage
                            )
                          }
                        })
                      : _c("div", { staticClass: "col-sm-12" })
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "panel-footer text-right" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-default",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: { click: _vm.closeButton }
          },
          [
            _vm._v(
              "\n       " + _vm._s(_vm._f("translate")("Close")) + "\n    "
            )
          ]
        ),
        _vm._v(" \n    "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: {
              type: "button",
              id: "selector__select-this-question_type_selector"
            },
            on: { click: _vm.selectButton }
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm._f("translate")("Select")) + "\n    "
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }